// John Eldhose 20200729
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Avatar, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { postAcademy } from './lib';
import { stream } from '../../lib/lib';
import Loading from '../../lib/Loading';
import Curriculum from './Curriculum';
import Discussion from './Discussion';
import RatingEdit from './RatingEdit';
import Course from './Course';
import AcademyUser from '../../../actions/AcademyUser';

class App extends Component {

  state = {
    loading: true,
    content: 'courses',
    open: 0
  }
  properties = { _learning_path: [], _course: [] };
    componentWillMount() {
    postAcademy('LearningPath', this.props.parms, (res) => {
      res.data.map((prop) => this.properties[prop.property].push(prop));
      this.setState({ loading: false });
    });
  }
  completed = (id) => {
    if(!this.props.user.learningpaths.includes(this.properties._learning_path[0].id)) {
      var completed = true;
      for(var i = 0; i < this.properties._course.length; i++)
        if(
          this.properties._course[i].id !== id &&
          !this.props.user.courses.includes(this.properties._course[i].id)
        ) {
          completed = false;
          break;
        }
        if(completed)
          this.props.AcademyUser('learningpath', this.properties._learning_path[0].id);
    }
  }
  courses = () => {
    return (
      <div>
        {this.properties._course.map((course, id) => (
          <ExpansionPanel key={id}
            expanded={this.state.open === course.id}
            onChange={(e, ex) => this.setState({ open: ex ? course.id : 0 })}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
              <Avatar
                alt='Course Icon'
                src={stream('academy/images/' + course.details.icon)}
              />
              <div style={{ textAlign: 'left', paddingLeft: '10PX' }}>
                <Typography variant='subheading'>
                  <b>{course.title}</b>
                </Typography>
                <Typography>
                  {(course.description.length > 50) ? (course.description.substring(0, 50) + ' . . .') : course.description}
                </Typography>
              </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {(this.state.open !== course.id) ? '' :
                <Course
                  parms={{id: course.id }}
                  learningpath={this.learningpath}
                  completed={this.completed}
                />
              }
            </ExpansionPanelDetails>
          </ExpansionPanel>
        ))}
      </div>
    );
  }
  content = () => {
    switch(this.state.content) {
      case 'discussion':
        return <Discussion parms={this.props.parms} />;
      case 'rating':
        return <RatingEdit parms={this.props.parms} />;
      case 'courses':
      default:
        return this.courses();
    }
  }

  render() {
    if(this.state.loading)
      return <Loading />;
    else {
      return (
        <Curriculum
          backgroundColor='#000'
          curriculum={this.properties._learning_path}
          defaultButton='courses'
          handleButton={(but) => this.setState({ content: but, open: 0 })}
          content={this.content}
          completed={this.props.user.learningpaths.includes(this.properties._learning_path[0].id)}
        />
      );
    }
  }
}

const mapStateToProps = (state) => {
  return ({ user: state.Academy.user.details });
}
const mapDispatchToProps = (dispatch) => ({
  AcademyUser: (prop, user) => dispatch(AcademyUser(prop, user))
});
const LearningPath = connect(mapStateToProps, mapDispatchToProps)(App);

export default LearningPath;



// WEBPACK FOOTER //
// ./src/components/home/academy/LearningPath.js